module.exports = __webpack_public_path__ + "img/24.79a14740.png";